import * as React from "react";
import "./LoadingSpinnerStyle.css";
import { useTranslation } from "react-i18next";
export var LoadingSpinner = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { className: "spinner-wrapper" },
        React.createElement("div", { className: "spinner-element" }, t("player.loading"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/loading-spinner/LoadingSpinner.tsx
// module id = 69
// module chunks = 1